import React, { useEffect, useState } from "react";
import { Paper, IconButton, Tooltip } from "@mui/material";
import MUIDataTable from "../../../components/LegacyMuiDataTable";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import { getTabs, deleteTab } from "../../../store/ducks/duckTab";
import CustomToolbar from "../../../components/CustomToolbar";
import NavBar from "../../../components/Navbar";
import ConfirmDelete from "../../../components/confirmDelete";
import { useStylesLayout } from "../../../styles/Layout";

import TabForm from "./components/TabForm";
const initialTab = {
  id: 0,
  label: "",
  deleted: false,
};
const Tab = () => {
  const { data, isLoading: loading } = useSelector((state) => state.tab);
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(initialTab);

  const [isEdit, setEdit] = useState(false);
  const classes = useStylesLayout();

  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    dispatch(getTabs());
  }, [dispatch]);

  const handleClickReload = () => {
    dispatch(getTabs());
  };

  const handleClickOpen =
    (tab, isEdit = true) =>
    (event) => {
      event.preventDefault();

      setTab(tab);
      setEdit(isEdit);

      setOpen(true);
    };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = (tab) => (event) => {
    event.preventDefault();
    setTab(tab);
    setOpenConfirm(true);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    let { id, label } = tab;

    dispatch(deleteTab(id)).then(() =>
      enqueueSnackbar(`Tab ${label} Deleted succesfully`, { variant: "info" }),
    );
    handleCloseConfirm();
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: true,
        display: false,
        hint: "Through the id it takes the value of the panel that is displayed",
      },
    },
    {
      name: "deleted",
      label: "Deleted",
      options: {
        filter: true,
        display: false,
        filterType: "dropdown",
        customFilterListOptions: { render: (v) => `Deleted: ${v}` },
        filterList: [false],
      },
    },
    {
      name: "label",
      label: "Label",
      options: {
        filter: true,
      },
    },
    {
      name: "value",
      label: "Value",
      options: {
        filter: true,
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return (
            <div style={{ maxWidth: 250 }}>
              <Tooltip title={"Edit"}>
                <IconButton aria-label="edit" size="small" onClick={handleClickOpen(rowData, true)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={rowData.deleted ? "Is already removed" : "Delete"}>
                <IconButton
                  aria-label="delete"
                  disabled={rowData.deleted}
                  size="small"
                  onClick={handleConfirm(rowData)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        setCellProps: () => ({ style: { width: 130, textAlign: "right" } }),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    expandableRowsHeader: false,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: true,
    customToolbar: () => {
      return (
        <CustomToolbar handleClick={handleClickOpen(initialTab)} handleReload={handleClickReload} />
      );
    },
    //Dense
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    textLabels: {
      body: {
        noMatch: loading ? "loading..." : "Sorry, no matching records found",
      },
    },
    setRowProps: (row, dataIndex, _rowIndex) => {
      let deleted = data[dataIndex]?.deleted;

      return (
        deleted && {
          style: { backgroundColor: "Gainsboro" },
          title: "Deleted",
        }
      );
    },
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };

  return (
    <>
      <NavBar />
      <Paper className={classes.administrationPaper}>
        <ConfirmDelete
          handleClose={handleCloseConfirm}
          handleDelete={handleDelete}
          message={`Are you sure to Delete the Tab with Name: ${tab.label}?`}
          open={openConfirm}
        />
        {open && tab && (
          <TabForm handleClose={handleClose} initialValues={tab} isEdit={isEdit} open={open} />
        )}
        <MUIDataTable columns={columns} data={data} options={options} title={"Tabs"} />
      </Paper>
    </>
  );
};

export default Tab;
